import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

const STATUS_MAP = {
  completed:     { tone: 'success' },
  in_progress:   { tone: 'info' },
  requested:     { tone: 'muted' },
  approved:      { tone: 'success' },
  under_review:  { tone: 'warning' },
  released:      { tone: 'primary' },
  released_to_client: { tone: 'success' },
  draft:         { tone: 'muted' },
  draft_ai_generated: { tone: 'info' },
  edited_by_hm:  { tone: 'warning' },
  pending_admin_review: { tone: 'accent' },
  discarded:     { tone: 'muted' },
  rejected:      { tone: 'destructive' },
  active:        { tone: 'success' },
  inactive:      { tone: 'muted' },
  Low:           { tone: 'success' },
  Medium:        { tone: 'warning' },
  High:          { tone: 'info' },
  'Very High':   { tone: 'accent' },
  Critical:      { tone: 'destructive' },
  submitted:     { tone: 'success' },
};

const TONE_CLS = {
  success:     'bg-success/10 text-success border-success/20',
  info:        'bg-info/10 text-info border-info/20',
  muted:       'bg-muted text-muted-foreground border-border',
  warning:     'bg-warning/10 text-warning border-warning/20',
  primary:     'bg-primary/10 text-primary border-primary/20',
  accent:      'bg-accent/10 text-accent border-accent/20',
  destructive: 'bg-destructive/10 text-destructive border-destructive/20',
};

const DOT_CLS = {
  success: 'bg-success', info: 'bg-info', muted: 'bg-muted-foreground',
  warning: 'bg-warning', primary: 'bg-primary', accent: 'bg-accent',
  destructive: 'bg-destructive',
};

// English fallback labels — used when no i18n key exists (e.g. risk bands).
const FALLBACK_LABELS = {
  completed: 'Completed', in_progress: 'In Progress', requested: 'Requested',
  approved: 'Approved', under_review: 'Under Review', released: 'Released',
  released_to_client: 'Released', draft: 'Draft', draft_ai_generated: 'Draft (AI)',
  edited_by_hm: 'Edited', pending_admin_review: 'Pending HM Admin review', discarded: 'Discarded',
  rejected: 'Rejected', active: 'Active', inactive: 'Inactive',
  submitted: 'Submitted',
  Low: 'Low risk', Medium: 'Medium', High: 'High', 'Very High': 'Very High', Critical: 'Critical',
};

export const StatusBadge = ({ status, className }) => {
  const { t } = useTranslation();
  const config = STATUS_MAP[status] || { tone: 'muted' };
  // Prefer the localized reports.status.* key; fall back to common.* then English.
  const localized = t(`reports.status.${status}`, { defaultValue: '' })
                 || t(`common.${status}`, { defaultValue: '' })
                 || FALLBACK_LABELS[status]
                 || status;
  return (
    <span className={cn('inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium', TONE_CLS[config.tone], className)}>
      <span className={cn('h-1.5 w-1.5 rounded-full', DOT_CLS[config.tone])} />
      {localized}
    </span>
  );
};
